import { ModelBase } from 'store/model-base';

export class CmsNowEsim extends ModelBase {
    public static storeName: string = 'cmsNowEsim';

    public getNewESIM: CmsNowEsimDetails;
    public eligibilityFailed: CmsNowErrorModal;
    public activation: CmsNowEsimActivation;
    public scanToDownload: CmsNowEsimManualDownload;
}